'use client';

import { c as _c } from "react/compiler-runtime";
import { useCourseLandingComponentsApi } from '@/lib/hooks/use-course-landing-components-api';
import { useUserHasOrganization } from '@/lib/hooks/use-user-has-organization';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { OrgBuyButtonResponse } from '@/features/course-landing-page/types/org-buy-button-response';
interface BuyButtonApiResponse {
  buy_button: {
    button: OrgBuyButtonResponse;
  };
}
export function useClcBuyButtonContext() {
  const $ = _c(2);
  const course = useClpCourse();
  const userHasOrganization = useUserHasOrganization();
  let t0;
  if ($[0] !== userHasOrganization) {
    t0 = {
      enabled: userHasOrganization
    };
    $[0] = userHasOrganization;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const query = useCourseLandingComponentsApi(course.id, "buy_button", t0);
  if (!userHasOrganization) {
    return;
  }
  return query.data?.buy_button?.button;
}